<template>
  <div class="mainNew">
    <div class="topTitle">
      <el-page-header @back="goBack" content="开班补课"> </el-page-header>
    </div>
    <div class="classRecord">
      <section>
        <el-form ref="form" :inline="true" size="mini" :model="form" @submit.native.prevent>
          <el-form-item label="科目">
            <el-select v-model="campusSubjectListId" multiple collapse-tags placeholder="请选择">
              <el-option v-for="item in campusSubjectList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="讲次名称">
            <el-input v-model="form.campusLessonListName" placeholder="请输入讲次名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="学员姓名">
            <el-input v-model="form.name" placeholder="请输入学员姓名" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="上课时间">
                        <el-date-picker @change="changeTime" v-model="form.time" type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item> -->

          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <div>
          <el-table ref="table1" :row-key="
              (row) => {
                return row.stuTchPlanId
              }
            " highlight-current-row :data="tableData" style="width: 100%" :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" :reserve-selection="true" :selectable="selectable">
            </el-table-column>
            <el-table-column prop="stuRealName" label="学员姓名">
            </el-table-column>
            <el-table-column prop="className" label="班级名称">
            </el-table-column>
            <el-table-column prop="subjectName" label="科目"> </el-table-column>
            <el-table-column prop="curriculumTitle" label="体系" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="lessonTitle" label="讲次" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="start_class_date" label="上课时间" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="lecturerName" label="上课老师">
            </el-table-column>
            <el-table-column prop="className" label="缺课状态">
              <template slot-scope="scope">
                <span v-if="scope.row.stuTchPlanSignState === 2">缺勤</span>
              </template>
            </el-table-column>
            <el-table-column prop="className" label="应扣/实扣" width="140">
              <template slot-scope="scope">
                <span>{{ scope.row.xm_tchplan_cost_lesson_hour }} /
                  <span v-if="scope.row.xm_over_lesson_hour == 0">{{
                    scope.row.xm_cost_lesson_hour
                  }}</span>
                  <span v-else>
                    <span v-if="scope.row.xm_over_lesson_hour === null">0</span>
                    <span v-else>
                      {{ scope.row.xm_over_lesson_hour }}
                    </span>
                  </span>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 30px; text-align: right">
            <el-pagination @current-change="handleCurrentChangeClass" :current-page="page_no" :page-size="page_size" layout="total,prev, pager, next" :total="total"></el-pagination>
          </div>
        </div>
      </section>
    </div>
    <div style="overflow:hidden;padding: 0 10px;">
      <div style="margin-right: 10px; width: 100%;padding: 10px;text-align: right;background: #fff;">
        <el-button type="primary" size="mini" @click="GoRollCall">去点名</el-button>
      </div>
    </div>
    <el-dialog title="创建班级" :visible.sync="dialogVisible" width="50%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :inline="true">
        <el-form-item label="上课日期" prop="classDate">
          <el-date-picker size="mini" value-format="yyyy-MM-dd" v-model="ruleForm.classDate" type="date" placeholder="选择日期" placement="bottom-start">
          </el-date-picker>
        </el-form-item>
        <br />
        <el-form-item label="上课时段" prop="startTime">
          <el-time-picker size="mini" format="HH:mm" value-format="HH:mm:00" v-model="ruleForm.startTime" :picker-options="{
              selectableRange: `00:00:00 - ${
                      ruleForm.endTime ? ruleForm.endTime : '23:59:59'
                    }`,
            }" placeholder="上课时间">
          </el-time-picker>
          <span> - </span>
        </el-form-item>
        <el-form-item label="" prop="endTime">
          <el-time-picker format="HH:mm" value-format="HH:mm:00" size="mini" v-model="ruleForm.endTime" :picker-options="{
              selectableRange: `${
                      ruleForm.startTime ? ruleForm.startTime : '00:00:00'
                    } - 23:59:59`,
            }" placeholder="下课时间">
          </el-time-picker>
          <span style="margin-left:10px;cursor: pointer;color: #3F9CFB;">
            <i @click="changeselectTime" class="el-icon-date"></i>
          </span>
        </el-form-item>
        <!-- <el-form-item label="上课时段" required size="mini">
          <el-time-picker v-model="ruleForm.startTime" placeholder="选择开始时间" value-format="HH:mm:ss">
          </el-time-picker>~
          <el-time-picker v-model="ruleForm.endTime" placeholder="选择结束时间" value-format="HH:mm:ss"></el-time-picker>
          <span style="margin-left:10px;cursor: pointer;color: #3F9CFB;">
            <i @click="changeselectTime" class="el-icon-date"></i>
          </span>
        </el-form-item> -->
        <br />
        <el-form-item label="上课老师:" prop="lecturer_id" v-if="$attrs.methodAuthTabView('查询').viewScope !== 1">
          <el-select size="mini" v-model="ruleForm.lecturer_id" clearable @change="getClassesList">
            <el-option :label="item.realName + ' ' + '(' + item.name + ')'" :value="item.id" v-for="(item, index) of teacherList" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="summitCreate('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择时间" :visible.sync="isShowTime" width="30%" top="10vh">
      <el-select v-if="isShowTime" size="mini" style="margin-left: 20px;width: 88%;" v-model="selectTime" cleatable>
        <el-option v-for="(item, index) in selectTimeList" :key="index" :label="item" :value="item">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="isShowTime = false">取消</el-button>
        <el-button size="small" type="primary" @click.stop="submitTime">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStuAbsenceRcordForMiss,
  getSubjectListForOpenClassOfMiss,
  getCurriculumtListForOpenClassOfMiss,
  getLessonListForOpenClassOfMiss,
  // getCampusTeacherList,
  createClassAndTchPlanForOpenClassOfMi,
  getBaseInfo,
} from '@/api/educational'
import { api_eduCampusSelectTchListByCampus } from '@/api/javaApi'
import moment from 'moment'

export default {
  data() {
    return {
      teacherList: [],
      dialogVisible: false,
      ruleForm: {
        classDate: null,
        startTime: null,
        endTime: null,
        lecturer_id: null,
      },
      stuIds: [],
      campusLessonListId: '',
      selfDynamicListId: '',
      campusSubjectListId: [],
      form: {
        time: [],
      },
      tableData: [],
      campusSubjectList: [],
      selfDynamicList: [],
      campusLessonList: [],
      page_size: 10,
      page_no: 1,
      total: 1,
      multipleSelection: [],
      rules: {
        classDate: [
          { required: true, message: '请输入上课时间', trigger: 'change' },
        ],
        cost_lesson_hour: [
          { required: true, message: '请输入授课课时', trigger: 'change' },
        ],
        startTime: [
          { required: true, message: '请输入上课时段', trigger: ['change', 'blur'] },
        ],
        endTime: [
          { required: true, message: '请输入下课时段', trigger: ['change', 'blur'] },
        ],
        lecturer_id: [
          { required: true, message: '请输入下课时段', trigger: 'change' },
        ],
      },
      selectTime: '',
      isShowTime: false,
      selectTimeList: [],
    }
  },
  mounted() {
    if (
      this.$store.state.user.selected_schools.length == 0 ||
      this.$store.state.user.selected_schools.length > 1
    ) {
      this.$message.warning('请选择1个目标校区')
      this.$router.push({
        name: 'classRecord',
      })
    } else {
      this.getStuAbsenceRcordForMiss()
      this.getSubjectListForOpenClassOfMiss()
    }
  },
  methods: {
    changeselectTime() {
      this.getBaseInfo()
      this.isShowTime = true
    },
    getBaseInfo() {
      this.selectTime = ''
      getBaseInfo().then((res) => {
        this.selectTimeList = []
        for (let key of res.educational_institution_class_day_list) {
          this.selectTimeList.push(
            `${key.start_class_date.slice(0, 5)}~${key.end_class_date.slice(
              0,
              5
            )}`
          )
        }

        this.$forceUpdate()
      })
    },
    submitTime(val) {
      console.log(val)
      console.log(this.selectTime)
      this.ruleForm.startTime = this.selectTime.slice(0, 5) + ':00'
      this.ruleForm.endTime = this.selectTime.slice(6, 12) + ':00'
      this.isShowTime = false
    },
    getClassesList(val) {
      console.log(val, 879)
    },
    summitCreate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let stuTchIdArr = []
          this.multipleSelection.map((item) => {
            stuTchIdArr.push(item.stuTchPlanId)
          })
          createClassAndTchPlanForOpenClassOfMi({
            stuTchIdArr: JSON.stringify(stuTchIdArr),
            lecturer_id: this.ruleForm.lecturer_id,
            class_date: this.ruleForm.classDate,
            start_class_date: this.ruleForm.startTime,
            end_class_date: this.ruleForm.endTime,
          }).then((res) => {
            console.log(res)
            this.$message.success('创建成功')
            this.$nextTick(() => {
              this.$refs.table1.clearSelection()
            })
            this.dialogVisible = false
            this.getStuAbsenceRcordForMiss()
          })
        }
      })
    },
    GoRollCall() {
      console.log(this.multipleSelection)
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择补课学员')
      } else {
        this.ruleForm.classDate = moment().format('YYYY-MM-DD')
        this.getCampusTeacherList()
        this.dialogVisible = true
      }
    },
    // 具有科目权限及课程体系的老师
    getCampusTeacherList() {
      if (this.$attrs.methodAuthTabView('查询').viewScope === 1) {
        return (this.ruleForm.lecturer_id = this.$store.state.user.userInfo.id)
      }
      api_eduCampusSelectTchListByCampus({
        eduCampusIdList: [this.multipleSelection[0].campusId],
      }).then((res) => {
        console.log('具有科目权限及课程体系的老师')
        console.log(res)
        this.teacherList = res //主讲老师
      })
    },
    selectable(row, index) {
      if (this.multipleSelection.length > 0) {
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (this.multipleSelection[i].stuId == row.stuId) {
            console.log(index, 789446545)
            if (this.multipleSelection[i].stuTchPlanId === row.stuTchPlanId) {
              return true
            } else {
              return false
            }
          }
        }
        return true
      }
      return true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val

      console.log(this.multipleSelection, 789446545)
    },
    getSubjectListForOpenClassOfMiss() {
      getSubjectListForOpenClassOfMiss({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
      }).then((res) => {
        console.log(res, 78454545)
        this.campusSubjectList = res.campusSubjectList
        this.campusSubjectList.map((item) => {
          this.campusSubjectListId.push(item.id)
        })
      })
    },
    // changeCampusSubjectList(val) {
    //     this.campusSubjectListId = val
    //     // this.getCurriculumtListForOpenClassOfMiss()
    // },
    getCurriculumtListForOpenClassOfMiss() {
      getCurriculumtListForOpenClassOfMiss({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        subjectId: this.campusSubjectListId,
      }).then((res) => {
        console.log(res, 7897446)
        this.selfDynamicList = res.campusCurriculumList
      })
    },
    changeSelfDynamicList(val) {
      console.log(val, 78945646)
      this.selfDynamicListId = val
      if (val === '') {
        this.campusLessonListId = ''
      }
      this.getLessonListForOpenClassOfMiss()
    },
    getLessonListForOpenClassOfMiss() {
      getLessonListForOpenClassOfMiss({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        curriculumIds: JSON.stringify([this.selfDynamicListId]),
        page_no: 1,
        page_size: 500,
      }).then((res) => {
        console.log(res, 7846545)
        this.campusLessonList = res.campusLessonList
      })
    },
    handleCurrentChangeClass(val) {
      this.page_no = val
      this.getStuAbsenceRcordForMiss()
    },
    changeCampusLessonList(val) {
      this.campusLessonListId = val
      this.getStuAbsenceRcordForMiss()
    },
    search() {
      this.page_no = 1
      this.getStuAbsenceRcordForMiss()
    },
    changeTime(val) {
      console.log(val, 78456)
      this.form.time = val
    },
    getStuAbsenceRcordForMiss() {
      getStuAbsenceRcordForMiss({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        lessonTitle: this.form.campusLessonListName,
        subjectIds: JSON.stringify(this.campusSubjectListId),
        stu_realname: this.form.name,
        xm_goods_id: this.$route.query.id,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res, 78446)
        this.total = res.total
        this.tableData = res.returnDataArr
        console.log(this.tableData, 789456)
      })
    },
    goBack() {
      this.$router.push({
        name: 'classRecord',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.745);
  }
}

.classRecord {
  min-height: calc(100% - 80px);
  background-color: #fff;
  margin: 10px;
  border-radius: 5px;

  section {
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
    padding-left: 10px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
}

.table-style {
}

.stu {
  width: 100%;
  height: 40px;
  background: rgba(51, 126, 245, 0.5);
  border: 2px solid rgb(51, 126, 245);
  border-radius: 5px;
  margin-top: 20px;
  line-height: 40px;
  box-sizing: border-box;
  padding-left: 10px;
}

.stu span {
  margin-right: 10px;
}

/deep/ .el-icon-info:before {
  color: rgb(51, 126, 245);
  margin-right: 10px;
}

/deep/ .el-table__header .el-checkbox {
  display: none;
}
</style>
